module.exports = __webpack_public_path__ + "img/visa.54e30edf.png";